const pa = {
  nav: {
    login: 'ਲੌਗਇਨ',
    bookNow: 'ਹੁਣੇ ਬੁੱਕ ਕਰੋ',
    dashboard: 'ਡੈਸ਼ਬੋਰਡ',
    back: 'ਪਿੱਛੇ',
    home: 'ਹੋਮ',
  },
  landing: {
    heroTitle1: 'ਅਸਮਾਨੀ ਸਫ਼ਰ,',
    heroTitle2: 'ਹੁਣ ਆਸਾਨ',
    heroSubtitle: 'ਭਾਰਤ ਦਾ ਪ੍ਰਮੁੱਖ ਹੈਲੀਕਾਪਟਰ ਚਾਰਟਰ ਐਗਰੀਗੇਟਰ। ਤਸਦੀਕਸ਼ੁਦਾ ਓਪਰੇਟਰਾਂ ਨਾਲ ਜੁੜੋ, ਤੁਰੰਤ ਉਡਾਣਾਂ ਬੁੱਕ ਕਰੋ।',
    bookYourFlight: 'ਆਪਣੀ ਉਡਾਣ ਬੁੱਕ ਕਰੋ',
    becomeOperator: 'ਓਪਰੇਟਰ ਬਣੋ',
    whyChoose: 'AirYatra ਕਿਉਂ ਚੁਣੋ?',
    verifiedOperators: 'ਤਸਦੀਕਸ਼ੁਦਾ ਓਪਰੇਟਰ',
    verifiedOperatorsDesc: 'ਸਾਰੇ ਓਪਰੇਟਰ AOC ਸਰਟੀਫਿਕੇਟ, ਬੀਮਾ ਅਤੇ ਸੁਰੱਖਿਆ ਪਾਲਣਾ ਨਾਲ ਪੂਰੀ ਤਰ੍ਹਾਂ ਤਸਦੀਕਸ਼ੁਦਾ ਹਨ।',
    bestPrices: 'ਵਧੀਆ ਕੀਮਤਾਂ',
    bestPricesDesc: 'AI-ਸੰਚਾਲਿਤ ਕੀਮਤ ਸੁਝਾਅ ਕਈ ਓਪਰੇਟਰਾਂ ਤੋਂ ਮੁਕਾਬਲੇ ਵਾਲੇ ਕੋਟੇਸ਼ਨ ਯਕੀਨੀ ਬਣਾਉਂਦੇ ਹਨ।',
    seamlessBooking: 'ਸੌਖੀ ਬੁਕਿੰਗ',
    seamlessBookingDesc: "ਕੋਟੇਸ਼ਨ ਬੇਨਤੀ ਤੋਂ ਡਿਜੀਟਲ ਟਿਕਟਾਂ ਤੱਕ, ਆਪਣੀ ਪੂਰੀ ਯਾਤਰਾ ਇੱਕੋ ਪਲੇਟਫਾਰਮ 'ਤੇ ਪ੍ਰਬੰਧਿਤ ਕਰੋ।",
    flightsCompleted: 'ਪੂਰੀਆਂ ਹੋਈਆਂ ਉਡਾਣਾਂ',
    verifiedOperatorsStat: 'ਤਸਦੀਕਸ਼ੁਦਾ ਓਪਰੇਟਰ',
    safetyRecord: 'ਸੁਰੱਖਿਆ ਰਿਕਾਰਡ',
    customerRating: 'ਗਾਹਕ ਰੇਟਿੰਗ',
    premiumServices: 'ਪ੍ਰੀਮੀਅਮ ਸੇਵਾਵਾਂ',
    elevateExperience: 'ਆਪਣੇ ਅਨੁਭਵ ਨੂੰ ਉੱਚਾ ਕਰੋ',
    premiumSubtitle: 'ਸਾਡੀ ਪ੍ਰੀਮੀਅਮ ਮੈਂਬਰਸ਼ਿਪ ਅਤੇ ਕਾਰਪੋਰੇਟ ਯਾਤਰਾ ਹੱਲਾਂ ਨਾਲ ਵਿਸ਼ੇਸ਼ ਲਾਭ ਪਾਓ',
    blackDesc: '20% ਤੱਕ ਛੋਟ, ਤਰਜੀਹੀ ਬੁਕਿੰਗ, ਸਮਰਪਿਤ ਪਾਇਲਟ ਅਤੇ ਵਿਸ਼ੇਸ਼ ਲਾਉਂਜ ਪਹੁੰਚ ਨਾਲ ਪ੍ਰੀਮੀਅਮ ਮੈਂਬਰਸ਼ਿਪ।',
    priorityQueue: 'ਤਰਜੀਹੀ ਬੁਕਿੰਗ ਕਤਾਰ',
    dedicatedManager: 'ਸਮਰਪਿਤ ਰਿਲੇਸ਼ਨਸ਼ਿਪ ਮੈਨੇਜਰ',
    freeCancellation: 'ਮੁਫ਼ਤ ਰੱਦ ਕਰਨਾ',
    exploreMembership: 'ਮੈਂਬਰਸ਼ਿਪ ਵੇਖੋ',
    corporateConsole: 'ਕਾਰਪੋਰੇਟ ਕੰਸੋਲ',
    corporateDesc: 'ਮਨਜ਼ੂਰੀ ਵਰਕਫਲੋ, ਬਜਟ ਅਤੇ ਇਕੱਠੀ ਬਿਲਿੰਗ ਨਾਲ ਉੱਦਮਾਂ ਲਈ ਕੇਂਦਰੀਕ੍ਰਿਤ ਯਾਤਰਾ ਪ੍ਰਬੰਧਨ।',
    employeeManagement: 'ਕਰਮਚਾਰੀ ਪ੍ਰਬੰਧਨ',
    budgetControls: 'ਬਜਟ ਨਿਯੰਤਰਣ',
    travelAnalytics: 'ਯਾਤਰਾ ਵਿਸ਼ਲੇਸ਼ਣ',
    corporateRegistration: 'ਕਾਰਪੋਰੇਟ ਰਜਿਸਟ੍ਰੇਸ਼ਨ',
    documentVault: 'ਦਸਤਾਵੇਜ਼ ਵਾਲਟ',
    vaultDesc: 'DGCA ਦਸਤਾਵੇਜ਼ਾਂ, ਬੀਮਾ, ਲਾਇਸੈਂਸਾਂ ਲਈ ਸੁਰੱਖਿਅਤ ਐਨਕ੍ਰਿਪਟਡ ਸਟੋਰੇਜ - ਮਿਆਦ ਖਤਮ ਹੋਣ ਦੀਆਂ ਚੇਤਾਵਨੀਆਂ ਅਤੇ ਵਰਜ਼ਨ ਨਿਯੰਤਰਣ ਨਾਲ।',
    encryption: 'AES-256 ਐਨਕ੍ਰਿਪਸ਼ਨ',
    expiryReminders: 'ਮਿਆਦ ਰੀਮਾਈਂਡਰ',
    secureSharing: 'ਸੁਰੱਖਿਅਤ ਸ਼ੇਅਰਿੰਗ',
    openVault: 'ਵਾਲਟ ਖੋਲ੍ਹੋ',
    loginToAccess: 'ਪਹੁੰਚ ਲਈ ਲੌਗਇਨ ਕਰੋ',
    readyTakeOff: 'ਉਡਾਣ ਲਈ ਤਿਆਰ?',
    ctaSubtitle: 'ਅੱਜ ਹੀ ਆਪਣਾ ਹੈਲੀਕਾਪਟਰ ਚਾਰਟਰ ਬੁੱਕ ਕਰੋ ਅਤੇ ਹਵਾਬਾਜ਼ੀ ਉੱਤਮਤਾ ਦਾ ਅਨੁਭਵ ਕਰੋ।',
    startBooking: 'ਬੁਕਿੰਗ ਸ਼ੁਰੂ ਕਰੋ',
    footerText: '© 2025 AirYatra. ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ। ਭਾਰਤ ਦਾ ਪ੍ਰਮੁੱਖ ਹੈਲੀਕਾਪਟਰ ਚਾਰਟਰ ਪਲੇਟਫਾਰਮ।',
  },
  booking: {
    title: 'ਆਪਣੀ ਉਡਾਣ ਬੁੱਕ ਕਰੋ',
    subtitle: 'AirYatra - ਪ੍ਰੀਮੀਅਮ ਏਅਰ ਮੋਬਿਲਿਟੀ ਸੇਵਾਵਾਂ',
    previous: 'ਪਿਛਲਾ',
    next: 'ਅਗਲਾ',
    loginPrompt: 'ਬੁਕਿੰਗ ਪੁੱਛਗਿੱਛ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਲੌਗਇਨ ਕਰੋ',
    loginBtn: 'ਲੌਗਇਨ',
    steps: {
      passengers: 'ਯਾਤਰੀ',
      booking_type: 'ਬੁਕਿੰਗ ਕਿਸਮ',
      route: 'ਰੂਟ',
      price_inquiry: 'ਕੀਮਤ',
    },
  },
  bookingForm: {
    selectAircraftType: 'ਜਹਾਜ਼ ਦੀ ਕਿਸਮ ਚੁਣੋ',
    maxPassengers: 'ਵੱਧ ਤੋਂ ਵੱਧ {{count}} ਯਾਤਰੀ',
    adultPassengers: 'ਬਾਲਗ ਯਾਤਰੀ',
    male: 'ਮਰਦ',
    female: 'ਔਰਤ',
    totalAdults: 'ਕੁੱਲ ਬਾਲਗ',
    children: 'ਬੱਚੇ (4 ਸਾਲ ਤੱਕ)',
    childrenFree: 'ਮੁਫ਼ਤ - ਵੱਧ ਤੋਂ ਵੱਧ 2 ਬੱਚੇ',
    flightType: 'ਉਡਾਣ ਦੀ ਕਿਸਮ',
    selectOption: '-- ਚੁਣੋ --',
    bookingFor: 'ਕਿਸ ਲਈ ਬੁਕਿੰਗ',
    bookingPurpose: 'ਬੁਕਿੰਗ ਦਾ ਮਕਸਦ',
    selected: 'ਚੁਣਿਆ ਗਿਆ',
    specifyPurpose: 'ਮਕਸਦ ਦੱਸੋ',
    pickupLocation: 'ਪਿਕਅੱਪ ਸਥਾਨ',
    selectPickupPoint: 'ਪਿਕਅੱਪ ਪੁਆਇੰਟ ਚੁਣੋ',
    dropLocation: 'ਡ੍ਰੌਪ ਸਥਾਨ',
    selectDropPoint: 'ਡ੍ਰੌਪ ਪੁਆਇੰਟ ਚੁਣੋ',
    estimatedDistance: 'ਅਨੁਮਾਨਿਤ ਦੂਰੀ',
    villageDocsTitle: 'ਪਿੰਡ ਲੈਂਡਿੰਗ - ਦਸਤਾਵੇਜ਼ ਲੋੜੀਂਦੇ',
    villageDocsDesc: 'ਪਿੰਡ/ਨਿੱਜੀ ਜ਼ਮੀਨ ਤੇ ਲੈਂਡਿੰਗ ਲਈ ਤੁਹਾਨੂੰ Authority ਤੋਂ ਹੇਠ ਲਿਖੇ ਦਸਤਾਵੇਜ਼ ਲੈਣੇ ਪੈਣਗੇ:',
    villageDocsNote: 'ਬੁਕਿੰਗ ਪੱਕੀ ਹੋਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਨੂੰ ਇਹ ਦਸਤਾਵੇਜ਼ ਅੱਪਲੋਡ ਕਰਨੇ ਪੈਣਗੇ। Admin/Operator ਤਸਦੀਕ ਕਰਨਗੇ, ਤਦ ਹੀ ਪਾਇਲਟ ਉਡਾਣ ਭਰੇਗਾ।',
    departureDate: 'ਰਵਾਨਗੀ ਦੀ ਤਾਰੀਖ',
    pickupTime: 'ਪਿਕਅੱਪ ਸਮਾਂ',
    additionalOptions: 'ਵਾਧੂ ਵਿਕਲਪ (ਵਿਕਲਪਿਕ)',
    waitingTime: 'ਉਡੀਕ ਸਮਾਂ (ਮਿੰਟ)',
    waitingTimeNote: 'ਪਹਿਲੇ 30 ਮਿੰਟ ਮੁਫ਼ਤ, ਫਿਰ ਚਾਰਜ ਲਾਗੂ',
    nightHalts: 'ਰਾਤ ਠਹਿਰਾਓ',
    nightHaltsNote: 'ਕਰੂ ਰਿਹਾਇਸ਼ ਚਾਰਜ ਸ਼ਾਮਲ',
    bookingSummary: 'ਬੁਕਿੰਗ ਸਾਰ',
    aircraftTypeLabel: 'ਜਹਾਜ਼ ਕਿਸਮ:',
    totalPassengersLabel: 'ਕੁੱਲ ਯਾਤਰੀ:',
    adults: 'ਬਾਲਗ',
    childrenLabel: 'ਬੱਚੇ',
    flightTypeLabel: 'ਉਡਾਣ ਕਿਸਮ:',
    pickupLabel: 'ਪਿਕਅੱਪ:',
    dropLabel: 'ਡ੍ਰੌਪ:',
    distanceLabel: 'ਦੂਰੀ:',
    dateTimeLabel: 'ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ:',
    at: 'ਵਜੇ',
    villageApprovalTitle: 'ਪਿੰਡ ਲੈਂਡਿੰਗ - ਐਡਮਿਨ ਮਨਜ਼ੂਰੀ ਲੋੜੀਂਦੀ',
    villageApprovalDesc: 'ਤੁਹਾਡੀ ਪੁੱਛਗਿੱਛ ਐਡਮਿਨ ਮਨਜ਼ੂਰੀ ਲਈ ਭੇਜੀ ਜਾਵੇਗੀ। ਮਨਜ਼ੂਰੀ ਤੋਂ ਬਾਅਦ ਭੁਗਤਾਨ ਚਾਲੂ ਹੋਵੇਗਾ।',
    priceBreakdown: 'ਕੀਮਤ ਵੇਰਵਾ',
    baseFlightCost: 'ਮੂਲ ਉਡਾਣ ਲਾਗਤ',
    flightCost: 'ਉਡਾਣ ਲਾਗਤ',
    positioningCost: 'ਪੋਜ਼ੀਸ਼ਨਿੰਗ ਲਾਗਤ (ਡੈੱਡ-ਲੈੱਗ)',
    roundTripDiscount: 'ਰਾਊਂਡ ਟ੍ਰਿਪ ਛੋਟ',
    operatorGrossCost: 'ਓਪਰੇਟਰ ਕੁੱਲ ਲਾਗਤ',
    additionalCharges: 'ਵਾਧੂ ਚਾਰਜ',
    waitingGroundHolding: 'ਉਡੀਕ / ਗਰਾਊਂਡ ਹੋਲਡਿੰਗ',
    nightHalt: 'ਰਾਤ ਠਹਿਰਾਓ ({{count}} ਰਾਤਾਂ)',
    crewAccommodation: 'ਕਰੂ ਰਿਹਾਇਸ਼ ਅਤੇ ਖਾਣਾ',
    fuelSurcharge: 'ਈਂਧਨ ਸਰਚਾਰਜ',
    platformFees: 'ਪਲੇਟਫਾਰਮ ਫੀਸ',
    convenienceFee: 'ਸਹੂਲਤ ਫੀਸ',
    insurance: 'ਬੀਮਾ',
    peakSurge: 'ਪੀਕ ਸੀਜ਼ਨ ਸਰਜ',
    platformCommission: 'ਪਲੇਟਫਾਰਮ ਕਮਿਸ਼ਨ',
    included: 'ਸ਼ਾਮਲ',
    helipadCharges: 'ਹੈਲੀਪੈਡ ਲੈਂਡਿੰਗ ਚਾਰਜ',
    totalLandingCharges: 'ਕੁੱਲ ਲੈਂਡਿੰਗ ਚਾਰਜ',
    taxableAmount: 'ਕਰਯੋਗ ਰਕਮ',
    totalGst: 'ਕੁੱਲ GST',
    grandTotal: 'ਕੁੱਲ ਰਕਮ',
    inclusiveTaxes: 'ਸਾਰੇ ਟੈਕਸ ਸਮੇਤ',
    operatorReceives: 'ਓਪਰੇਟਰ ਨੂੰ ਮਿਲੇਗਾ',
    specialRequirements: 'ਖਾਸ ਲੋੜਾਂ (ਵਿਕਲਪਿਕ)',
    specialRequirementsPlaceholder: 'ਕੋਈ ਖਾਸ ਬੇਨਤੀ ਜਾਂ ਲੋੜਾਂ...',
    submitting: 'ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...',
    submitApproval: 'ਮਨਜ਼ੂਰੀ ਲਈ ਭੇਜੋ',
    generateInquiry: 'ਪੁੱਛਗਿੱਛ ਭੇਜੋ',
    approvalNote: 'ਪਿੰਡ ਲੈਂਡਿੰਗ ਲਈ ਐਡਮਿਨ ਮਨਜ਼ੂਰੀ ਜ਼ਰੂਰੀ ਹੈ।',
    inquiryNote: 'ਪੁੱਛਗਿੱਛ ਤੋਂ ਬਾਅਦ, ਓਪਰੇਟਰ ਤੁਹਾਨੂੰ ਕੋਟ ਭੇਜਣਗੇ।',
    formRestored: 'ਫਾਰਮ ਡੇਟਾ ਬਹਾਲ ਕੀਤਾ ਗਿਆ!',
    selectAircraftError: 'ਕਿਰਪਾ ਕਰਕੇ ਜਹਾਜ਼ ਦੀ ਕਿਸਮ ਚੁਣੋ',
    minAdultError: 'ਘੱਟੋ-ਘੱਟ 1 ਬਾਲਗ ਯਾਤਰੀ ਲੋੜੀਂਦਾ',
    maxChildrenError: 'ਵੱਧ ਤੋਂ ਵੱਧ 2 ਬੱਚਿਆਂ ਦੀ ਇਜਾਜ਼ਤ',
    selectFlightTypeError: 'ਕਿਰਪਾ ਕਰਕੇ ਉਡਾਣ ਦੀ ਕਿਸਮ ਚੁਣੋ',
    selectBookingForError: 'ਕਿਸ ਲਈ ਬੁਕਿੰਗ ਹੈ ਚੁਣੋ',
    selectPurposeError: 'ਬੁਕਿੰਗ ਦਾ ਮਕਸਦ ਚੁਣੋ',
    selectPickupError: 'ਪਿਕਅੱਪ ਸਥਾਨ ਚੁਣੋ',
    selectDropError: 'ਡ੍ਰੌਪ ਸਥਾਨ ਚੁਣੋ',
    selectDateError: 'ਰਵਾਨਗੀ ਦੀ ਤਾਰੀਖ ਚੁਣੋ',
    selectTimeError: 'ਪਿਕਅੱਪ ਸਮਾਂ ਚੁਣੋ',
    priceWaitError: 'ਕੀਮਤ ਦੀ ਗਣਨਾ ਨਹੀਂ ਹੋਈ! ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ',
    inquirySubmitted: 'ਪੁੱਛਗਿੱਛ ਜਮ੍ਹਾਂ! ਓਪਰੇਟਰ ਜਲਦੀ ਜਵਾਬ ਦੇਣਗੇ',
    noteVillageApproval: 'ਪਿੰਡ ਲੈਂਡਿੰਗ ਲਈ ਐਡਮਿਨ ਮਨਜ਼ੂਰੀ ਜ਼ਰੂਰੀ',
    notePriceEngine: 'ਏਵੀਏਸ਼ਨ-ਗ੍ਰੇਡ ਪ੍ਰਾਈਸਿੰਗ ਇੰਜਣ ਦੁਆਰਾ ਗਣਨਾ',
    noteFinalPrice: 'ਅੰਤਿਮ ਕੀਮਤ ਓਪਰੇਟਰ ਦੁਆਰਾ ਪੁਸ਼ਟੀ ਹੋਵੇਗੀ',
    docCollectorNoc: 'ਕਲੈਕਟਰ NOC',
    docFireDept: 'ਫਾਇਰ ਵਿਭਾਗ ਦੀ ਰਸੀਦ',
    docPoliceStation: 'ਸਥਾਨਕ ਥਾਣੇ ਦੀ ਰਸੀਦ',
    docSpDcp: 'SP/DCP ਰਸੀਦ',
  },
  options: {
    helicopter: 'ਹੈਲੀਕਾਪਟਰ',
    chartered_plane: 'ਚਾਰਟਰਡ ਜਹਾਜ਼',
    one_hour: '1 ਘੰਟੇ ਦੀ ਉਡਾਣ',
    two_hour: '2 ਘੰਟੇ ਦੀ ਉਡਾਣ',
    half_day: 'ਅੱਧਾ ਦਿਨ',
    full_day: 'ਪੂਰਾ ਦਿਨ',
    multi_city: 'ਮਲਟੀ-ਸਿਟੀ',
    point_to_point: 'ਪੁਆਇੰਟ-ਟੂ-ਪੁਆਇੰਟ',
    self: 'ਆਪਣੇ ਲਈ',
    friend_family: 'ਦੋਸਤ ਅਤੇ ਪਰਿਵਾਰ',
    company: 'ਕੰਪਨੀ / ਕਾਰਪੋਰੇਟ',
    political: 'ਸਿਆਸੀ / VIP',
    other: 'ਹੋਰ',
    wedding: 'ਵਿਆਹ',
    temple_yatra: 'ਮੰਦਰ ਯਾਤਰਾ',
    company_tour: 'ਕਾਰਪੋਰੇਟ ਟੂਰ',
    election_tour: 'ਚੋਣ ਪ੍ਰਚਾਰ',
    medical_emergency: 'ਮੈਡੀਕਲ ਐਮਰਜੈਂਸੀ',
    film_shooting: 'ਫਿਲਮ ਸ਼ੂਟਿੰਗ',
    general_tour: 'ਆਮ ਯਾਤਰਾ',
    pilgrimage: 'ਤੀਰਥ ਯਾਤਰਾ',
    business: 'ਬਿਜ਼ਨਸ ਮੀਟਿੰਗ',
  },
};

export default pa;
